import React, { useState, useEffect } from 'react';
import AnimateHeight from 'react-animate-height';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import './ProjectSettings.scss';
import EditProjectPageRedesign from '../EditProjectPage.redesign';
import DocumentManagement from 'src/components/layout/DocumentManagement';
import actions from 'src/actions';
import DialogList from 'src/dialogs';
import { useDispatch } from 'react-redux';
import Button from 'src/components/controls/forms/redesign/FormButton';
import useFetch from 'use-http';
import FileDownloadUtil from 'src/util/FileDownloadUtil';
import { LandSystem } from 'src/models/LandSystem';

interface IProjectSettingsProps {
    showDialog?: (dialogName: string) => void;
    hideDialog?: () => void;
    onPageUpdated?: () => void;
}

const ProjectSettings = (props: IProjectSettingsProps) => {
    const [showPD, setShowPD] = useState<string | number>('auto');
    const [refreshProjectData, setRefreshProjectData] = useState<boolean>(false);
    const [docManagementContext, setDocManagementContext] = useState<string>('');
    const dispatch = useDispatch();
    const { get, response } = useFetch();

    useEffect(() => {
        if (!!refreshProjectData) {
            setTimeout(() => {
                setRefreshProjectData(false);
            }, 500);
        }
    }, [refreshProjectData]);

    const filesUploaded = () => {
        dispatch(actions.layout.hideDialog());
    };

    const getSpreadsheetTemplate = async () => {
        let fileName = '';
        if (docManagementContext === 'uploader') {
            fileName = 'Uploader_Template.xlsx';
        } else {
            fileName = 'ROWLine_Uploader.xlsx';
        }

        await get(`/v1.0/s3bucket/ReferenceDocs/${fileName}`);
        if (response.ok) {
            await response.blob().then((blob) => {
                convertToExcel(blob);
            });
        }
    };

    const convertToExcel = async (blob: Blob) => {
        const arrayBuffer = await FileDownloadUtil.readBlobAsArrayBuffer(blob);
        let newBlob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

        const blobUrl = window.URL.createObjectURL(newBlob);
        const a = document.getElementById(`a_uploader`) as HTMLAnchorElement;
        a.href = blobUrl;
        a.download = 'Uploader_Template';
        a.click();
        window.URL.revokeObjectURL(blobUrl);
    };

    const handleLandSystemLogic = (landSystem: LandSystem) => {
        if (landSystem === LandSystem.RightOfWay) {
            setDocManagementContext('row-uploader');
        } else {
            setDocManagementContext('uploader');
        }
    };

    return (
        <>
            <div className="settings">
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                    <RHFLegend title="Project Settings" />
                </div>
                <div style={{ margin: '3rem 1rem' }}>
                    <Button
                        text="Upload Spreadsheet"
                        size="medium"
                        onClick={() => dispatch(actions.layout.showDialog(DialogList.DOCUMENT_MANAGEMENT))}
                        className="mr-2"
                        disabled={docManagementContext.length === 0}
                    />
                    <Button
                        text="Download Spreadsheet Template"
                        size="medium"
                        onClick={() => getSpreadsheetTemplate()}
                        className="mr-2"
                        disabled={docManagementContext.length === 0}
                    />
                    <a style={{ display: 'hidden' }} id="a_uploader" />
                </div>
                <section className="project_details" style={{ margin: '3rem auto' }}>
                    <div style={{ cursor: 'pointer', paddingBottom: '1rem' }} onClick={() => setShowPD(showPD === 'auto' ? 0 : 'auto')}>
                        <div style={{display: 'flex' , justifyContent: 'space-between'}} >
                            <RHFLegend title="Project Details" />
                        </div>
                    </div>
                    <AnimateHeight
                        duration={500}
                        height={showPD}
                        children={<EditProjectPageRedesign
                            setRefreshProjectData={setRefreshProjectData}
                            showDialog={props.showDialog}
                            hideDialog={props.hideDialog}
                            onPageUpdated={props.onPageUpdated}
                            handleLandSystemLogic={handleLandSystemLogic}
                        />}
                    />
                </section>
            </div>

            <DocumentManagement filesUploaded={filesUploaded} context={docManagementContext} />
        </>
    );
};

export default ProjectSettings;



// WEBPACK FOOTER //
// ./src/components/project/sections/ProjectSettings.redesign.tsx